<template>
  <div class="v-login-roleselect">
    <div class="role-main">
      <h5 class="role-tit">选择您的身份，尊享个性化服务</h5>
      <ul class="role-select">
        <li @click="selectRole(ROLE.IDENTITY1)"
          :class="{ active: roleId  === ROLE.IDENTITY1.code }">
          <div class="li-inner">
            <span class="icon dealers"></span>
            <p>{{ROLE.IDENTITY1.label}}</p>
          </div>
        </li>
        <li @click="selectRole(ROLE.IDENTITY2)"
          :class="{ active: roleId  === ROLE.IDENTITY2.code }">
          <div class="li-inner">
            <span class="icon decorationcompany"></span>
            <p>{{ROLE.IDENTITY2.label}}</p>
          </div>
        </li>
        <li @click="selectRole(ROLE.IDENTITY3)"
          :class="{ active: roleId  === ROLE.IDENTITY3.code }">
          <div class="li-inner">
            <span class="icon designer"></span>
            <p>{{ROLE.IDENTITY3.label}}</p>
          </div>
        </li>
        <li @click="selectRole(ROLE.IDENTITY4)"
          :class="{ active: roleId  === ROLE.IDENTITY4.code }">
          <div class="li-inner">
            <span class="icon owner"></span>
            <p>{{ROLE.IDENTITY4.label}}</p>
          </div>
        </li>
      </ul>
      <div class="btn-box">
        <a class="btn" href="javascript:void(0)" @click="setRole">完成选择</a>
      </div>
    </div>
  </div>
</template>

<script>
import defaults from './libs/defaults';
import { ENV_API_HOST, USER_ROLE } from './libs/constants';
import {
  apiSetRole,
} from './libs/service';

export default {
  name: 'v-login-roleselect',
  props: {
    options: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      step: 1,
      ROLE: USER_ROLE,
      roleId: USER_ROLE.IDENTITY3.code,
    };
  },
  computed: {
    useOptions() {
      return Object.assign({}, defaults, this.options);
    },
  },
  methods: {
    // 选择身份
    selectRole(role) {
      this.roleId = role.code || '';
    },
    // 选择用户角色
    setRole() {
      apiSetRole(ENV_API_HOST[this.useOptions.env].www, this.roleId, (result) => {
        this.$emit('clickCallback', result, this.roleId);
      }, (result) => {
        this.$emit('clickCallback', result);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './libs/mixin.scss';

.v-login-roleselect {
  .btn {
    @include loginBtn;
    width: 120px;
    margin: 0 auto;
  }
  .role-main {
    padding: 60px 36px;
  }
  .role-tit {
    color: #333;
    text-align: center;
    font-size: 20px;
    margin: 0 auto 60px;
  }
  .role-desc {
    color: #999;
    font-size: 14px;
    text-align: center;
  }
  .role-select {
    @include resetUl;
    text-align: center;
    @include flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    li {
      position: relative;
      cursor: pointer;
      flex-grow: 0;
      flex-shrink: 0;
      @include flex;
      justify-content: center;
      align-items: center;
      width: 165px;
      height: 180px;
      margin: 0 15px;
      border: 1px solid #D9D9D9;
      color: $mainColor;
      border-radius: 4px;
      &:hover,
      &.active {
        border-color: $mainColor;
      }
      &.active {
        &:after {
          content: '';
          display: block;
          width: 20px;
          height: 20px;
          position: absolute;
          right: 10px;
          top: 10px;
          background: url('./imgs/select.png') center no-repeat;
          background-size: 20px auto;
        }
      }
      .icon {
        display: inline-block;
        width: 97px;
        height: 97px;
        background: url('./imgs/designer.png') center no-repeat;
        background-size: 97px;
        &.owner {
          background-image: url('./imgs/owner.png')
        }
        &.merchant {
          background-image: url('./imgs/merchant.png')
        }
        &.designcompany {
          background-image: url('./imgs/designcompany.png')
        }
        &.decorationcompany {
          background-image: url('./imgs/decorationcompany.png')
        }
        &.dealers {
          background-image: url('./imgs/dealers.png')
        }
        &.brandingbusiness {
          background-image: url('./imgs/brandingbusiness.png')
        }
      }
      p {
        font-size: 16px;
        font-weight: 600;
        margin-top: 13px;
      }
    }
  }
  .btn-box {
    padding-top: 40px;
  }
}
</style>
